






















export default

	props:
		titleText: String
		openIconClass: String
		closeIconClass: String

	data: -> open: false

	computed:

		# Determine which sidebar icon to show
		sidebarIconClass: -> if @open then @closeIconClass else @openIconClass

	watch:

		# Relay open state
		open: -> @$emit 'toggle', @open

